// extracted by mini-css-extract-plugin
export var compactFilters = "_dh-4";
export var detailImage = "_dh-1";
export var dropdownContainer = "_dh-2";
export var imageContainer = "_dh-0";
export var selectedCard = "_dh-3";